import { AdviserConfiguration } from "../../../Wrap/Models/Models/Adviser/Configuration/AdviserConfiguration";
import { AdviserConfigurationInstruction } from "../../../Wrap/Models/Models/Adviser/Configuration/AdviserConfigurationInstruction";
import { AdviserConfigurationInstructionUpdateAction } from "../../../Wrap/Constants/Enums/Domain/AdviserConfigurationInstructionUpdateAction";
import { ServiceValidationError as Error } from "../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { AdviserConfigurationCollection } from "../../../Wrap/Models/Models/Adviser/Configuration/AdviserConfigurationCollection";
import { CreateAdviserConfigurationInstructionQuery as PostCreateQuery } from "../../../Wrap/Models/Models/Adviser/Configuration/CreateAdviserConfigurationInstructionQuery";
import { Company } from "../../../Wrap/Models/Models/Company/Company";
import { CompanyClient } from "../../../Wrap/Api/User/Company";

import { AdviserConfigurationClient } from "../../../Wrap/Api/Adviser/AdviserConfiguration";
import { AdviserConfigurationInstructionClient } from "../../../Wrap/Api/Adviser/AdviserConfigurationInstruction";
import { AdviserConfigurationHistoryClient } from "../../../Wrap/Api/Adviser/AdviserConfigurationHistory";
import { UpdateAdviserConfigurationInstructionClient } from "../../../Wrap/Api/Adviser/UpdateAdviserConfigurationInstruction";
import { SubmitAdviserConfigurationInstructionClient } from "../../../Wrap/Api/Adviser/SubmitAdviserConfigurationInstruction";
import { CancelAdviserConfigurationInstructionClient } from "../../../Wrap/Api/Adviser/CancelAdviserConfigurationInstruction";

import { SharedDispatcher } from "../Stores/Variable";
import { CustomActionType } from "../Stores/SharedStoreStatic";

export class LandingAction {
    public static loadUserCompany(callBack?: (val: Company) => void): void {
        const client = new CompanyClient();
        const promise = client.get();
        promise.onSuccess((company) => {
            SharedDispatcher.dispatch({
                actionType: CustomActionType.GetCompany,
                payload: company,
            });
            if (callBack) {
                callBack(company);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getAdviserConfiguration(hierarchyId: string, callBack: (val: AdviserConfiguration) => void) {
        const client = new AdviserConfigurationClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((res) => {
            callBack(res);
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getConfigureData(
        instructionId: number,
        callBack?: (val: AdviserConfigurationInstruction) => void
    ): void {
        const client = new AdviserConfigurationInstructionClient();
        const promise = client.get(instructionId);

        promise.onSuccess((res) => {
            SharedDispatcher.dispatch({ actionType: CustomActionType.Success, payload: res });
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
            // Shared.Stores.SharedDispatcher.dispatch({actionType:Shared.Stores.CustomActionType.Error,payload:err})
        });
    }

    public static getHistory(
        hierarchyId: string,
        minrow: number,
        maxrow: number,
        callBack?: (val: AdviserConfigurationCollection) => void
    ) {
        const client = new AdviserConfigurationHistoryClient();
        const promise = client.get(hierarchyId, minrow, maxrow);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static postCreate(query: PostCreateQuery, callBack?: (val: AdviserConfigurationInstruction) => void) {
        const client = new AdviserConfigurationInstructionClient();
        const promise = client.post(query);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postLog(
        adviserConfigurationInstruction: AdviserConfigurationInstruction,
        adviserConfigurationInstructionUpdateAction: AdviserConfigurationInstructionUpdateAction,
        callBack?: (val: Error[]) => void
    ) {
        const client = new UpdateAdviserConfigurationInstructionClient();
        const promise = client.post(adviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postContactDetails(
        adviserConfigurationInstruction: AdviserConfigurationInstruction,
        adviserConfigurationInstructionUpdateAction: AdviserConfigurationInstructionUpdateAction,
        callBack?: (val: Error[]) => void
    ) {
        const client = new UpdateAdviserConfigurationInstructionClient();
        const promise = client.post(adviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postAssetType(
        adviserConfigurationInstruction: AdviserConfigurationInstruction,
        adviserConfigurationInstructionUpdateAction: AdviserConfigurationInstructionUpdateAction,
        callBack?: (val: Error[]) => void
    ) {
        const client = new UpdateAdviserConfigurationInstructionClient();
        const promise = client.post(adviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postPerformanceMethod(
        adviserConfigurationInstruction: AdviserConfigurationInstruction,
        adviserConfigurationInstructionUpdateAction: AdviserConfigurationInstructionUpdateAction,
        callBack?: (val: Error[]) => void
    ) {
        const client = new UpdateAdviserConfigurationInstructionClient();
        const promise = client.post(adviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postSubmit(instructionId: number, callBack?: (val: AdviserConfiguration) => void) {
        const client = new SubmitAdviserConfigurationInstructionClient();
        const promise = client.post(instructionId);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
            SharedDispatcher.dispatch({ actionType: CustomActionType.SubmitConfig, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
    public static postCancel(instructionId: number, callBack?: (val: Error[]) => void) {
        const client = new CancelAdviserConfigurationInstructionClient();
        const promise = client.post(instructionId);

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
            SharedDispatcher.dispatch({ actionType: CustomActionType.CancelConfig, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
